import React from 'react';

import { Svg, SvgG, SvgPath, SvgProps } from '@rbilabs/universal-components';

import Styles from 'styles/constants';
import { primitive } from 'styles/constants/primitives';

export const MARKER_DIMENSIONS = {
  width: 28,
  height: 28,
  viewBox: '0 0 28 28',
} as const;

const USER_MARKER_PATHS = {
  outerCircle:
    'M14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z',
  innerCircle:
    'M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z',
} as const;

const COLORS = {
  outerCircle: primitive.bk.$white,
  innerCircle: '#3780D6',
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SHADOW_STYLES: any = {
  shadowColor: Styles.shadowColor,
  shadowOffset: {
    width: 1.2,
    height: 1.2,
  },
  shadowRadius: 1.5,
  shadowOpacity: 0.8,
  elevation: 10, // for android
};

interface UserMarkerProps extends SvgProps {
  accessibilityLabel?: string;
  testID?: string;
}

const defaultAccessibilityLabel = 'User location marker';

export const UserMarker: React.FC<UserMarkerProps> = ({
  accessibilityLabel,
  testID,
  ...svgProps
}) => {
  return (
    <Svg
      width={MARKER_DIMENSIONS.width}
      height={MARKER_DIMENSIONS.height}
      viewBox={MARKER_DIMENSIONS.viewBox}
      fill="none"
      style={SHADOW_STYLES}
      accessible={true}
      accessibilityLabel={accessibilityLabel || defaultAccessibilityLabel}
      testID={testID}
      {...svgProps}
    >
      <SvgG>
        <SvgPath
          fillRule="evenodd"
          clipRule="evenodd"
          d={USER_MARKER_PATHS.outerCircle}
          fill={COLORS.outerCircle}
        />
      </SvgG>
      <SvgG>
        <SvgPath
          fillRule="evenodd"
          clipRule="evenodd"
          d={USER_MARKER_PATHS.innerCircle}
          fill={COLORS.innerCircle}
        />
      </SvgG>
    </Svg>
  );
};

export const userMarkerSvg = `<svg width="${MARKER_DIMENSIONS.width}" height="${MARKER_DIMENSIONS.height}" viewBox="${MARKER_DIMENSIONS.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="${USER_MARKER_PATHS.outerCircle}"
      fill="${COLORS.outerCircle}"
    />
  </g>
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="${USER_MARKER_PATHS.innerCircle}"
      fill="${COLORS.innerCircle}"
    />
  </g>
</svg>`;
